import { useAuthStore } from 'src/entities/user/store/useAuthStore';

import { Typography } from '../ui';

export const NEXT_SAMPLE_50_DISCOUNT = 'next_sample_50%';

const LOCAL_DISCOUNT_BANNER_TEXTS = {
  [NEXT_SAMPLE_50_DISCOUNT]:
    'Congratulations! An affiliate code has been applied to your first sample. You can save up to $250 in total on this purchase.'
};
const GLOBAL_DISCOUNT_BANNER_TEXTS = {
  [NEXT_SAMPLE_50_DISCOUNT]:
    'Congratulations! The affiliate code has been applied: 50% of your 1st sample cost will be on us.'
};

interface DiscountBannerProps {
  localOrGlobal?: 'local' | 'global';
}

export default function DiscountBanner({ localOrGlobal }: DiscountBannerProps) {
  const selectedOrganization = useAuthStore(
    (state) => state.selectedOrganization
  );
  const isLoading = useAuthStore((state) => state.isLoading);

  if (isLoading) {
    return null;
  }

  if (
    !selectedOrganization?.discounts ||
    !(selectedOrganization?.discounts.length > 0)
  ) {
    return null;
  }
  const discountId = selectedOrganization.discounts[0];
  const discountText =
    localOrGlobal === 'local'
      ? LOCAL_DISCOUNT_BANNER_TEXTS[
          discountId as keyof typeof LOCAL_DISCOUNT_BANNER_TEXTS
        ]
      : GLOBAL_DISCOUNT_BANNER_TEXTS[
          discountId as keyof typeof GLOBAL_DISCOUNT_BANNER_TEXTS
        ];

  if (!discountText) {
    return null;
  }

  return (
    <div className="bg-gray-2 p-2 text-center m-4 rounded-xl">
      <Typography
        variant="body-2"
        weight="medium"
        className="flex items-center justify-start gap-2 text-left"
      >
        <span
          role="img"
          aria-label="celebration"
          className="bg-white min-w-[40px] min-h-[40px] w-[40px] h-[40px] rounded-md text-xl flex items-center justify-center"
        >
          🎉
        </span>
        {discountText}
      </Typography>
    </div>
  );
}
